import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name ColumnFilter
     * @memberof app
     *
     * @description
     * Should match the backend service `ColumnFilterResource`.
     * By the time of writing this, the `ColumnFilterResource` has yet to be implemented.
     *
     * @author flzemke.btc
     */
    angular.module('app').factory('ColumnFilter', columnFilterResource);

    function columnFilterResource($resource, API_URL) {
        return $resource(
            API_URL.COLUMN_FILTER,
            {},
            {
                query: {
                    isArray: false
                }
            }
        );
    }
})();
